import React from "react";

const TeamDashboardContext = React.createContext();
export default TeamDashboardContext;
